module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/bookcase/bookTexture2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/bookcase/bookTexture2.jpg
// module id = 522
// module chunks = 0